<script setup lang="ts">
import { useVModel } from '@vueuse/core'

import { searchFilterType } from '~/types/search.type'
import BcSelect from '~/ui/Select/BcSelect.vue'

interface IProps {
  modelValue: searchFilterType
}

const props = defineProps<IProps>()
const searchModel = useVModel(props, 'modelValue')

const searchFilterList = computed(() => {
  return Object.values(searchFilterType).map(filter => {
    if(filter === searchFilterType.TOKEN) {
      return {
        label: 'Token / NFT',
        value: searchFilterType.TOKEN,
      }
    }
    return {
      label: capitalizeFirstLetter(filter),
      value: filter,
    }
  })
})
</script>

<template>
  <BcSelect
    v-model="searchModel"
    :options="searchFilterList"
  />
</template>

<style scoped lang="scss">

</style>